import { Button, Callout, Collapse } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __, jsonToData } from "src/libs/utilities"
import { ILand, ITrack } from "../../data/interfaces" 
import actions from "src/modules/pe-basic-module/data/actions"
import { default as festActions} from "../../data/actions"
import { IMPORT_TRACKS } from "../../data/actionTypes"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { ID } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface ITracksImportUtilityProps {
   
}
const TracksImportUtility = (props: ITracksImportUtilityProps): JSX.Element => {
    const { landId }            = useParams() 
    const [ land, setLand ]     = useState<ILand>( {} as ILand)
    const [ tracks, setTracks ] = useState<ITrack[]>([])
    const [ chosenTracks, setChosenTracks ] = useState<ITrack[]>([])

    useEffect(() => {
        
    }, [])

    const onLand = (value: ILand) => { 
        setLand(value)
        actions(
            GET_FEED_ACTION, 
            {
                data_type: "PEFestTrack",
                land_id: value.id,
            }
        )
        .then(res => { 
            setTracks(  res.feed as ITrack[] )
        })
    }
    const onChoose = (value: ID[]) => {
        const _trks: ITrack[] = value.map(id => {
            return tracks.find(t => t.id === id)!
        }) 
        setChosenTracks( _trks )
    }
    const onSend = () => { 
        console.log( chosenTracks.map(track => ({
            ...track, 
            bookmarks: [],
            likes: [], 
        })) ) 

        festActions(
            IMPORT_TRACKS, 
            {
                track_ids: chosenTracks.map( track => track.id ),
                land_id: land.id,
                to_land_id: landId, 
            }
        )
        .then(res => {
            console.log(  res.data.importTracks )
            
        })
    }
    return <div className='pe-tracks-import-utility  small-container '>
       <Callout className=" mb-4">
            <div className="descr text-force-contrast opacity_5">
                {__("This utility assigns Tracks from other Lands.")}
            </div>
        </Callout>
        <div className=" mt-4 mb-2 text-uppercase ">
            { __( "Choose Land" ) }
        </div>
        <div className="container">
            <FieldInput
                type={ SCALAR_TYPES.EXTERNAL }
                value={ land }
                component="Land"
                editable
                onChange={ onLand }
                placeholder="Select Land"
            />
        </div>
        <Collapse isOpen={!!land?.id} className="w-100"> 
            <div className="py-3 "> 
                <div className=" mt-4 mb-2 text-uppercase ">
                    { __( "Choose Tracks for import" ) }
                </div>
                <div className="container">
                    <FieldInput
                        editable
                        multiple={ true }
                        value={ chosenTracks.map(r => {
                            //const d = { _id: r.id, title: r.title } 
                            const d = r.id 
                            return d
                        }) }
                        values={ tracks.map(r => ({ _id:r.id, title: r.title })) }
                        type={ SCALAR_TYPES.TAGS }
                        onChange={ onChoose }
                    />
                </div>
                
            </div>
        </Collapse>
        <Collapse isOpen={ !!land?.id && !!tracks.length } className="w-100"> 
            <div className="py-3">
                <Button intent="danger" size="large" onClick={onSend}>
                    {__("Start import just now!")}
                </Button>
            </div>
        </Collapse>
    </div>
}
export default TracksImportUtility